var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"text-align":"center","display":"block"}},[_c('Logo',{staticClass:"py-10"})],1),(_vm.isLogin)?_c('div',[_c('Login')],1):_c('div',[_c('Credentials')],1),_c('auth-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }